module.exports = __webpack_public_path__ + "img/driver.7342fbba.svg";